import theme from '@styles/theme';
export default {
  creativeModal: {
    p: {
      marginBottom: '20px',
      fontSize: theme.fontSizes.text
    },
    padding: '0 24px 24px',
    minWidth: ['unset', 'unset', '472px'],
    display: 'flex',
    flexDirection: 'column'
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    gap: '24px',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    width: '100%'
  }
};